import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {NdjsonService} from "./ndjson.service";
import {BytesPipe} from "./bytes-pipe";

@Component({
  selector: 'app-ndjson-status',
  templateUrl: './ndjson-status.component.html',
  styleUrl: './ndjson-status.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BytesPipe]
})
export class NdjsonStatusComponent {
  download = inject(NdjsonService);
}
